import { apiPaths } from '../../config'
import { http } from '../../services/index'
import { factorySetStateAction } from '../factory'

const actions = {
  SET_STATE: 'report/SET_STATE',
  GET_CLINIC_DAILY_REPORT: 'report/GET_CLINIC_DAILY_REPORT',
  GET_OPEN_DAILY_REPORT: 'report/GET_OPEN_DAILY_REPORT',
}

export const reportSetState = factorySetStateAction(actions.SET_STATE)

export const getClinicDailyReport = (data) =>
  http
    .get(apiPaths.Clinic.apiClinicDailyReport, data, {})
    .then((res) => res)
    .catch(() => [])

export const getClinicDailyReportClinic = (data) =>
  http
    .get(apiPaths.Clinic.apiClinicDailyReportClinic, data, {})
    .then((res) => res)
    .catch(() => [])

export const getOpenDailyReport = (data) =>
  http
    .get(apiPaths.Clinic.apiOpenDailyReport, data, {})
    .then((res) => res)
    .catch(() => 'error')

export default actions
